// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SearchUpsell-cls1___218a18ddc5ffea14cc9{/*!*/}.SearchUpsell-cls2___3bb8883a9a5f6ca0434{letter-spacing:normal;line-height:1.3em}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "SearchUpsell-cls1___218a18ddc5ffea14cc9",
	"cls2": "SearchUpsell-cls2___3bb8883a9a5f6ca0434 SearchUpsell-cls1___218a18ddc5ffea14cc9"
};
export default ___CSS_LOADER_EXPORT___;
